import BrandActions from './BrandActions.Container';

export default BrandActions;
